import { render, staticRenderFns } from "./SpotifyConnectCard.vue?vue&type=template&id=56ebd3c0&"
import script from "./SpotifyConnectCard.vue?vue&type=script&lang=ts&"
export * from "./SpotifyConnectCard.vue?vue&type=script&lang=ts&"
import style0 from "./SpotifyConnectCard.vue?vue&type=style&index=0&id=56ebd3c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports